export interface AppInfo {
  id: string;
  version: string;
  name: string;
}
